import { render, staticRenderFns } from "./SolanHeaderPure.vue?vue&type=template&id=28696e8a&scoped=true&"
import script from "./SolanHeaderPure.vue?vue&type=script&lang=ts&"
export * from "./SolanHeaderPure.vue?vue&type=script&lang=ts&"
import style0 from "./SolanHeaderPure.vue?vue&type=style&index=0&id=28696e8a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28696e8a",
  null
  
)

export default component.exports